import { Box, LinearLoader, Typography } from "@drone-js/core";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";

export const Loader = () => {
    const {
        automaticPropertySelectionCms: { loaderGenericTitle, loaderSubtitle },
    } = usePropertySelectionViewModelValue();

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="calc(100vh - 126px)"
        >
            <Box width="100%" maxWidth="256px">
                <LinearLoader color="primary" label="loading" />
            </Box>
            <Typography variant="body-default-strong" textColor="base.default" textAlign="center" mt="32" mb="16">
                {loaderGenericTitle}
            </Typography>
            <Typography variant="body-default" textColor="base.subtle" textAlign="center">
                {loaderSubtitle}
            </Typography>
        </Box>
    );
};
